import * as React from "react";

const Button = ({ disabled, loading, children }) => {
    return (
        <button
            className="h-[50px] px-[60px] relative inline-flex items-center justify-center whitespace-nowrap rounded-[100px] text-base font-bold leading-snug border border-transparent transition-colors active:ring-4 disabled:opacity-25 disabled:cursor-not-allowed bg-brand-primary text-brand-white border-brand-primary hover:bg-brand-primary-darken active:bg-brand-primary-darken active:ring-brand-primary-darken/40"
            disabled={disabled || loading}
        >
            <span>{children}</span>
        </button>
    );
};

Button.displayName = "Button";

export { Button };
